import script from "./PmIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PmIcon.vue?vue&type=script&setup=true&lang=js"

import "./PmIcon.vue?vue&type=style&index=0&id=d42eb818&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d42eb818"]])

export default __exports__